import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="top-center"
      className="toaster group"
      closeButton
      toastOptions={{
        closeButtonAriaLabel: "关闭通知",
        descriptionClassName: "!text-foreground",
        classNames: {
          toast: "!pr-10",
          title: "!text-foreground",
          description: "!text-foreground",
          closeButton:
            "!top-2 !bg-background !text-foreground !border-border hover:!bg-accent hover:!text-accent-foreground",
        },
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--toast-close-button-start": "unset",
          "--toast-close-button-end": "0.5rem",
          "--toast-close-button-transform": "translate(0, 0)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
